import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6 16.0566V3.94336C6 3.10459 6.8941 2.68455 7.417 3.27763L12.7569 9.33427C13.081 9.70192 13.081 10.2981 12.7569 10.6657L7.417 16.7223C6.8941 17.3155 6 16.8954 6 16.0566Z",
		fill: "#0D2976"
	})
});
export default SvgCaretRight;
